import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'main',
    'form',
    'questions',
    'question',
    'next',
    'prev',
  ]

  connect () {
    this.slidePosition = 0
    this.slideWidth = this.mainTarget.clientWidth

    this.questionsTarget.style.width = `${this.questionTargets.length * this.slideWidth}px`
    this.questionsTarget.style.transform = 'translate3d(0px, 0px, 0px)'

    this.questionTargets.forEach((element, index) => {
      if (index === this.slidePosition) {
        element.style.visibility = 'visible'
        element.style.height = 'auto'
      } else {
        element.style.visibility = 'hidden'
        element.style.height = '0'
      }
    })

    // バリデーションエラー再レンダリング時など、フォームが入力済みの場合はJS状態を復元する
    this.restorePrefilledState()
  }

  // バリデーションエラー再レンダリング時に失われたJS状態を復元し、各ステップのnextボタンを再評価する
  restorePrefilledState () {
    // move_in_status の選択状態に応じた日付フィールドのdisabled状態を復元する。
    // changeMoveInStatus のロジックは desktop/mobile コントローラーが担うため、
    // 選択済みのラジオボタンに合成inputイベントを発火して委譲する。
    // ※ desktop/mobile コントローラーが slider より先に data-controller に宣言されている必要がある
    //   （先に connect したコントローラーの action リスナーが張られるため。順序を逆にすると無音で壊れる）。
    const checkedMoveInStatus = this.formTarget.querySelector('input[name*="move_in_status"]:checked')
    if (checkedMoveInStatus) {
      checkedMoveInStatus.dispatchEvent(new Event('input', { bubbles: true }))
    }

    // 全ステップのnextボタンを入力済み状態に基づいて有効化する
    this.nextTargets.forEach((_, index) => {
      if (this.checkRequired(index)) {
        this.nextTargets[index].disabled = false
      }
    })
  }

  checkRequired (currentStep) {
    // 画面内の項目の入力チェックを行い、すべて入力されていた場合は「次へ」ボタンを有効にする
    let valid = true
    const inputNames = []
    const requiredInputs = this.questionTargets[currentStep].querySelectorAll('input:required, select:required, textarea:required')
    const formData = new FormData(this.formTarget)

    requiredInputs.forEach(input => {
      if (!inputNames.includes(input.name) && !input.hidden && !input.disabled) {
        inputNames.push(input.name)
      }
      // textareaの必要文字数チェック: CSSクラスの状態に依存せず、実際の値で直接判定する。
      // CSSクラス依存だと再レンダリング時に常にrequirement-not-metが付いたままになりバグる。
      if (input.type === 'textarea') {
        const value = formData.get(input.name) || ''
        const minimum = input.dataset.minimum ? Number(input.dataset.minimum) : null
        const maximum = input.dataset.maximum ? Number(input.dataset.maximum) : null
        if ((minimum !== null && value.length < minimum) || (maximum !== null && value.length > maximum)) {
          formData.set(input.name, '')
        }
      }
    })

    inputNames.forEach(name => {
      if (!formData.get(name)) {
        valid = false
      }
    })

    return valid
  }

  changeValue (e) {
    const currentStep = e.target.dataset.current - 1

    // textareaの最低文字数の判定時に、文字数判定処理よりも先行する場合があるためsetTimeoutを入れる
    setTimeout(() => {
      if (this.checkRequired(currentStep)) {
        this.nextTargets[currentStep].disabled = false
      } else {
        this.nextTargets[currentStep].disabled = true
      }
    }, 100)
  }

  clickNext (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition < this.questionTargets.length - 1 && this.slidePosition === currentPosition - 1) {
      this.slidePosition += 1
      this.setMovedStyle()
      window.scrollTo(0, 0)
    }
  }

  clickPrev (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition > 0 && this.slidePosition === currentPosition - 1) {
      this.slidePosition -= 1
      this.setMovedStyle()
      window.scrollTo(0, 0)
    }
  }

  setMovedStyle () {
    this.questionTargets.forEach((element, index) => {
      if (index === this.slidePosition) {
        element.style.visibility = 'visible'
        element.style.height = 'auto'
      } else {
        element.style.visibility = 'hidden'
        element.style.height = '0'
      }
    })
    this.questionsTarget.style.transform = `translate3d(-${this.slideWidth * this.slidePosition}px, 0px, 0px)`
  }
}
